module.exports = __webpack_public_path__ + "static/media/logo-ig-ads.ae63f236.svg";